<template>
  <div id="index">
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"
          ><img src="@/assets/img/esc_fan.png" alt=""
        /></i>
        <h4 class="header_title">{{ comment_total }}条评论</h4>
      </header>
      <!-- 内容 -->
      <div class="comments_ul">
        <div class="comments_li" v-for="(liem, index) in comment">
          <div class="user_text flex_between">
            <div class="flex_start flex_items">
              <img
                class="portrait"
                v-if="liem.userimage"
                :src="liem.userimage"
                alt=""
              />
              <img class="portrait" v-else :src="liem.headimage" alt="" />
              <span class="user_name" v-if="liem.username">{{
                liem.username
              }}</span>
              <span class="time" v-else>{{ liem.nickname }}</span>
            </div>
            <div class="flex_center goods_botton" @click.stop="goodsFun(index)">
              <i><img src="@/assets/img/dianzan.png" alt="" /></i>
              {{ liem.goods }}
            </div>
          </div>
          <div
            class="text_center"
            v-if="liem.type == 1"
            v-html="liem.content"
          ></div>
          <div class="text_center li_r_img" v-if="liem.type == 2">
            <img :src="liem.content" alt="" />
          </div>
          <div class="time flex_end">
            {{ liem.create_time }}
          </div>
        </div>
      </div>
      <!-- /* 底部按钮 */ -->
      <div class="chat_input flex_between">
        <div class="text_content">
          <div class="operator-box-btn flex_between">
            <span class="inp_img_box" @click="upImgFun">
              <input
                type="file"
                class="inp_img"
                @change="handleChange"
                id="imgInp"
                ref="inputer"
                multiple
                accept="image/*"
              />
              <img src="@/assets/img/tupian.png" alt="" srcset="" />
            </span>

            <div class="submit">
              <i class="face-icon flex_center">
                <img src="@/assets/img/smiling.png" alt="" />
              </i>
              <input
                @keydown="bayFun"
                class="text inpu_div"
                placeholder="请输入..."
              />
            </div>
            <div class="submit-btn flex_center" @click.stop="out">发送</div>
          </div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
    </div>
  </div>
</template>

<script>
import { AnalyticEmotion, Hashtable } from "@/assets/js/sinaFaceAndEffec.js";
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
import "@/assets/js/pcmain.js";
import "@/assets/css/pcsinaFaceAndEffec.css";
import "@/assets/css/pcmain.css";
export default {
  name: "index",
  data() {
    return {
      id: 0, //推文id
      page: 1, //翻页
      user: {}, //用户信息
      comment_total: 0, //总数
      comment: [], //列表
      is_app: this.$store.state.is_app,
    };
  },
  computed: {},
  components: {
    LoginPrompt,
  },
  watch: {
    "$route.query.id": {
      handler(newVal, oldVal) {
        this.id = newVal;
        this.getComment();
        //判断newVal有没有值监听路由变化
      },
      deep: true,
    },
  },
  methods: {
    upImgFun() {
      if (this.is_app) {
        let that = this;
        let index = layer.open({
          title: ["选择方式", "background-color: #FF4351; color:#fff;"],
          content:
            '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">拍照</div>' +
            '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">相册</div>',
        });
        $("#session").click(() => {
          //拍照
          android.pictureMethod(1);
          layer.close(index);
        });
        $("#circle").click(() => {
          //相册
          android.pictureMethod(2);
          layer.close(index);
        });
      }
    },

    goodsFun(index) {
      //点赞
      let that = this;
      this.$post("comment_goods", {
        comment_id: this.comment[index].comment_id,
      }).then((res) => {
        that.comment[index].goods = res.data;
      });
    },
    addImg() {
      $(".li_r_img img").on("click", function () {
        $(this).ImgZoomIn("");
      });
    },
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.prompt.popupFun();
      }
    },
    promptFun() {
      //提示弹窗回调
      this.$router.push("/m_registered");
    },
    goBackward() {
      //返回上一页
      this.$router.go(-1);
    },
    bayFun(e) {
      //点击回车
      if (e.which == 13) {
        this.out();
      }
    },
    upImg(img) {
      this.send(img, 2);
    },
    //上传图片
    handleChange: function (e) {
      let _this = this;
      let img = e.target.files[0];
      this.judgeUser();
      let images = "";
      var reader = new FormData();
      reader.append("file", img);
      var layerOpen = layer.open({
        type: 2,
        content: "上传中。。。",
      });
      //发送图片消息
      $.ajax({
        type: "POST", //提交方式
        url: this.$URL + "upload", //路径
        data: reader,
        processData: false,
        contentType: false,
        success: function (result) {
          //返回数据根据结果进行相应的处理
          layer.close(layerOpen);
          _this.upImg(result.data);
        },
      });
    },
    out: function () {
      //发送
      var inputText = $(".inpu_div").val();
      if (!inputText) {
        layer.open({
          content: "请输入内容啊啊啊",
          time: true,
          skin: "msg",
        });
        return false;
      }
      this.judgeUser();
      if (this.USER().is_words == 1) {
        layer.open({
          content: "你已被禁言!",
          time: true,
          skin: "msg",
        });
      } else {
        this.send(AnalyticEmotion(inputText), 1);
      }
    },
    send(content, type) {
      //发送评论
      let that = this;
      this.$post("comment", {
        news_id: this.id,
        member_id: this.USER().id,
        content: content,
        type: type,
      }).then((res) => {
        layer.open({
          content: "评论成功",
          time: true,
          skin: "msg",
        });
        $(".inpu_div").val("");
        setTimeout(() => {
          that.page = 1;
          that.getComment();
        }, 1000);
      });
    },
    getUser() {
      let that = this;
      this.REFRESH_USER();
      setTimeout(() => {
        that.user = this.USER();
        that.getComment();
      }, 500);
    },
    getComment() {
      //获取评论
      let that = this;
      if (this.page == 1) {
        this.comment = [];
      }
      this.$post("news_comment", {
        news_id: this.id,
        limit: 10,
        page: this.page,
      }).then((res) => {
        that.comment_total = res.data.total;
        that.comment = res.data.data;
        setTimeout(() => {
          that.addImg();
        }, 500);
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
  },
  mounted() {
    this.getComment();
    this.id = this.$route.query.id;
    this.getUser();
    this.getShare();
    window.upImg = this.upImg;

    $(".face-icon").SinaEmotion($(".text"));
    $(".face-icon").click(function () {
      $("#emotions").css({ left: 0, width: "100%" });
    });
    if (this._isMobile()) {
    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
  },
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
/* 聊天输入框 */

.chat_input {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  min-height: 4.7rem;
  padding: 0.8rem 1.5rem;
  background: #fff;
  box-shadow: 0.3rem 0 2.3rem rgba(71, 71, 71, 0.17);
  padding-right: 1rem;
}

.chat_input > i {
  width: 2rem;
}

.text_content {
  width: 100%;
}

.chat_input i.give {
  width: 2.5rem !important;
  height: 2.5rem !important;
  border-radius: 50% !important;
  padding: 0 !important;
  /* overflow: hidden !important; */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: none !important;
  position: relative !important;
  margin-right: 0.4rem;
  background-image: linear-gradient(
    90deg,
    rgba(255, 74, 89, 1),
    rgba(235, 38, 54, 1)
  );
}

.chat_input > i.give > i {
  width: 2rem;
  height: 2rem;
}

.chat_input i.give.giveLike {
  background: #ccc;
  color: rgba(255, 74, 89, 1);
}

.chat_input i.give img {
  width: 1.2rem;
  box-shadow: none !important;
  background: none !important;
}

.chat_input .input_div {
  width: calc(100% - 9rem);
  background: rgba(244, 246, 249, 1);
  border-radius: 0.4rem;
  border: 0.1rem solid rgba(226, 226, 226, 1);
  padding: 0 0 0 1.3rem;
  min-height: 3.5rem;
}

.chat_input .input_div > .input {
  width: calc(100% - 4rem);
  border: 0;
  background: transparent;
  outline: transparent;
  font-size: 1.3rem;
  color: #999999;
  line-height: 1.6em;
  height: 100%;
}

.chat_input .input_div > span {
  color: #ffffff;
  font-size: 1.2rem;
  padding: 0.8rem 0.6rem;
  background-color: red;
  border-radius: 0 0.4rem 0.4rem 0;
}

.submit {
  flex: 1;
  width: auto;
  padding: 0 0.9rem;
  height: 3.6rem;
}

.submit input {
  display: block;
  flex: 1;
}

.face-icon {
  width: 1.8rem;
  margin-right: 0.8rem;
}

.inp_img_box {
  position: relative;
  display: inline-flex;
  margin-right: 1.4rem;
  overflow: hidden;
}

.inp_img_box .inp_img {
  position: absolute;
  top: 0;
  opacity: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: inline-block;
}

.submit-btn {
  width: 5.5rem;
  height: 3.6rem;
  border-radius: 0.2rem;
  background: #f24d5b;
  color: #fff;
  font-size: 1.4rem;
  margin-left: 1.2rem;
}

/* 评论记录 */
.comments_ul {
  padding: 2rem 1.9rem;
}

.comments_ul .comments_li {
  margin-bottom: 1.4rem;
}

.comments_li .user_text .portrait {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
  margin-right: 0.5rem;
  object-fit: contain;
}

.comments_li .user_text .user_name {
  font-size: 1.1rem;
  color: #2d82db;
  margin-right: 1.2rem;
  line-height: 1.1em;
}

.comments_li .user_text .time {
  font-size: 1rem;
  color: #999999;
  line-height: 1.1em;
}

.comments_li .text_center {
  margin-top: 0.8rem;
  padding-left: 3rem;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6em;
}

.comments_li .text_center img {
  max-width: 60%;
}

.time {
  font-size: 1.1rem;
  color: #666;
  margin-top: 1rem;
}

.goods_botton {
  font-size: 1.1rem;
  color: #333;
  line-height: 1.1em;
}
.goods_botton > i {
  width: 1.5rem;
  margin-right: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_column_comments.vue